import React, { } from 'react';
import moment from 'moment';

import { ICongelamentosEmLoteExtrato } from '../../interfaces';

import { convertHora, convertMoedaBRDoJSComAte3CasasDecimais } from '../../../../../../services/Conversores';
import { useGetColumnSearchProps } from '../../../../../../hooks/FilterTable/string';
import { useGetColumnSearchPropsData } from '../../../../../../hooks/FilterTable/date';
import { useGetColumnSearchPropsObj } from '../../../../../../hooks/FilterTable/objString';

export const useAbaCongelamentosEmLote = () => {

    const refContagemDoFiltro = React.useRef<Array<any>>([]);

    const columns = [
        {
            title: 'Qtd Registros',
            dataIndex: 'qtdeRegistros',
            ...useGetColumnSearchProps('qtdeRegistros'),
            width: '10%',
            render: (qtdeRegistros: any) => {

                if (qtdeRegistros) {

                    return qtdeRegistros
                }
                return
            },
        },
        {
            title: 'Hora',
            dataIndex: 'createdAt',
            ...useGetColumnSearchPropsData('createdAt'),
            width: '2%',
            sorter: (a: any, b: any) => {

                let aMonMen: any = null
                let bMonMen: any = null
                if (a.createdAt) {
                    aMonMen = moment(a.createdAt).unix()
                } else {
                    aMonMen = 0
                }
                if (b.createdAt) {
                    bMonMen = moment(b.createdAt).unix()
                } else {
                    bMonMen = 0
                }

                return aMonMen - bMonMen
            },
            showSorterTooltip: false,
            render: (data: any) => {

                return (
                    convertHora(data)
                )
            },
        },
        {
            title: 'Usuário',
            dataIndex: 'usuario',
            ...useGetColumnSearchPropsObj('usuario'),
            width: '10%',
            sorter: (a: any, b: any) => a.usuario.nome.localeCompare(b.usuario.nome),
            showSorterTooltip: false,
            render: (usuario: any) => {
                return usuario.nome;
            }
        },
        {
            title: 'Custo',
            dataIndex: 'custo',
            ...useGetColumnSearchProps('custo'),
            width: '6%',
            sorter: (a: ICongelamentosEmLoteExtrato, b: ICongelamentosEmLoteExtrato) => a.custo - b.custo,
            showSorterTooltip: false,
            render: (valor: number) => {
                return `R$ ${convertMoedaBRDoJSComAte3CasasDecimais(valor, true)}`;
            }
        },
    ];

    return {
        refContagemDoFiltro,
        columns,
    }
}
